import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DEMO_ORG_ID = 'demo-stellar-vanguard';

/**
 * Wraps org route elements. Allows unauthenticated access to the demo org.
 * All other orgs require authentication.
 */
export default function OrgAuthGuard({ children }) {
  const { currentUser } = useAuth();
  const { orgId } = useParams();

  // Demo org is publicly accessible
  if (orgId === DEMO_ORG_ID) return children;

  // All other orgs require login
  if (!currentUser) return <Navigate to="/login" />;

  return children;
}
